<template>
  <input
    type="hidden"
    name="csrf_token"
    :value="token"
  >
</template>

<script>
export default {
  name: 'CSRF',
  data() {
    return {
      token: null,
    };
  },
  mounted() {
    this.checkCSRFToken();
  },
  methods: {
    checkCSRFToken() {
      const $meta = document.querySelector('meta[name="csrf-token"]');

      if ($meta) {
        this.token = $meta.getAttribute('content');
        this.$emit('setCSRFToken', this.token);
      }
    },
  },
};
</script>
